export const simpleReplaceCrypto = (str, isEncrypt = true) => {
    const map = {
        'a': 'z', 'b': 'y', 'c': 'x',
        'd': 'w', 'e': 'v', 'f': 'u',
        // 添加更多映射
    }

    return str.split('').map(char => {
        if (isEncrypt) {
            return map[char.toLowerCase()] || char;
        } else {
            const reverseMap = Object.fromEntries(
                Object.entries(map).map(([k, v]) => [v, k])
            );
            return reverseMap[char.toLowerCase()] || char;
        }
    }).join('')
}
export const timeCalculate = (time1, time2) => {
    const ftmDate = (d = '') => {
        return d.replace(new RegExp('-', 'g'), '/').split('.')[0]
    }
    const parseTime = (timeStr) => {
        const [hours, minutes, seconds] = ftmDate(timeStr).split(':').map(Number)
        return { hours, minutes, seconds }
    }
    const t1 = parseTime(time1)
    const t2 = parseTime(time2)

    // 计算总秒数
    const totalSeconds1 = t1.hours * 3600 + t1.minutes * 60 + t1.seconds
    const totalSeconds2 = t2.hours * 3600 + t2.minutes * 60 + t2.seconds

    const diffSeconds = Math.abs(totalSeconds2 - totalSeconds1)

    const interval = {
        hours: Math.floor(diffSeconds / 3600),
        minutes: Math.floor((diffSeconds % 3600) / 60),
        seconds: diffSeconds % 60,
        totalMinutes: Math.floor(diffSeconds / 60),
        totalSeconds: diffSeconds
    }
    if (interval.hours > 0) {
        return `${interval.hours}小时${interval.minutes}分${interval.seconds}秒`
    } else if (interval.minutes > 0) {
        return `${interval.minutes}分${interval.seconds}秒`
    } else {
        return `${interval.seconds}秒`
    }
}